import { render, staticRenderFns } from "./ModulesOverview.vue?vue&type=template&id=e0bd46c2"
import script from "./ModulesOverview.vue?vue&type=script&lang=js"
export * from "./ModulesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports